import Budgets from "@components/modules/budgets/listing";
import { NavigationProjects } from "@components/widgets/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { type WithIdProps, withId } from "@src/components/HOC/with-id/withId";
import { FullScreenContainer } from "@src/components/ui-kit";
import { getQueryParamOptional } from "@src/utils/routing";
import { createFileRoute } from "@tanstack/react-router";
import { uniqueId } from "lodash";
import { useRouter } from "next/router";
import { useState } from "react";

const Page = ({ id }: WithIdProps) => {
  const { query } = useRouter();
  const budgetId = getQueryParamOptional("budget_id", query);
  const projectId = getQueryParamOptional("project_id", query);

  const [iframeKey, _] = useState(uniqueId());

  return (
    <MainLayout
      fullWidth
      noBottomMargin
      noGutters
      title={t`Budgets`}
      navigation={<NavigationProjects projectId={id} />}
    >
      <FullScreenContainer noBottomMargin>
        <Budgets
          iframeKey={iframeKey}
          page={"budgets"}
          embedded
          proposals={true}
          showMenu={false}
          budgetId={budgetId}
          projectId={projectId}
        />
      </FullScreenContainer>
    </MainLayout>
  );
};

const RouteComponent = withId(Page);

export const Route = createFileRoute("/projects/budgets/edit")({
  component: RouteComponent,
});
